import { IconProps } from "../IconProps";

export const IconUser36 = ({ className, color = "#FFF" }: IconProps) => {
  return (
    <svg
      className={className}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 34C5.5 27.1271 11.0964 21.5556 18 21.5556C24.9036 21.5556 30.5 27.1271 30.5 34M25.1429 9.11111C25.1429 13.0385 21.9448 16.2222 18 16.2222C14.0551 16.2222 10.8571 13.0385 10.8571 9.11111C10.8571 5.18375 14.0551 2 18 2C21.9448 2 25.1429 5.18375 25.1429 9.11111Z"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
